module.exports = __webpack_public_path__ + "img/img_kuang@2x.12514395.png";